<div class="badge" [style.background-color]="backgroundColor" [style.color]="textColor">
  <ng-container *ngIf="iconSrc">
    <img [src]="iconSrc" alt="icon" class="badge-icon" />
  </ng-container>
  <span class="badge-text">{{ text }}</span>
</div>
